import { swal } from 'promise-alert';

export default err => {
    console.error(err);
    swal(err.message);
};
